import { useSelector } from "react-redux";
import { useQuery } from "@tanstack/react-query";

import { createAxiosInstance } from "api/axiosConfig";

export const useGetChats = () => {

  const tenantVal =
    useSelector((state) => state.auth.user?.tenant) ||
    localStorage.getItem("kinesin-tenant");

  return useQuery({
    queryKey: ["chats", tenantVal],
    queryFn: async () => {
      const axiosInstance = createAxiosInstance();
      const response = await axiosInstance.get(`${tenantVal}/chat/getmychats`);

      return response.data || [];
    },
    // Tighter polling so unread badges + last-message sort surface a
    // new DM within ~10 seconds. Single /chat/getmychats call so cheap
    // to refetch. Real-time still wants a WebSocket backend — see the
    // backend prompt at the bottom of this work.
    refetchInterval: 10000,
    refetchOnWindowFocus: true,
    enabled: !!tenantVal,
    meta: { errorMessage: "Error fetching chats" },
  });
};
